<template>
	<div class="addPosition">
		<el-container>
			<el-header class="management_header">
				<div class="nidrlogo">
					<img src="../../image/zsdb_logo.png" />
				</div>
				<div class="accoutInfo">
					<span class="headerText">尊敬的管理员{{showID}}，您好！</span>
					<span class="divider">|</span>
					<el-link type="primary" class="headerText" @click="addControl()">+新增管理员</el-link>
					<span class="divider">|</span>
					<el-link type="primary" @click="exit()" class="headerText">退出</el-link>
				</div>
			</el-header>
			<el-container>
				<el-aside class="management_aside">
					<el-menu default-active="1" class="personalmenu" background-color="#545c64" text-color="#fff"
						active-text-color="#ffd04b">
						<el-menu-item index="1">
							<span class="menuText" slot="title">新增岗位</span>
						</el-menu-item>
						<el-menu-item index="2" @click="gotoreset()">
							<span class="menuText" slot="title">查询/修改岗位信息</span>
						</el-menu-item>
						<el-submenu index="3">
							<template slot="title">
								<span class="menuText">查看简历</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="3-1" @click="gotolookupresumeByName()">按人名查找</el-menu-item>
								<el-menu-item index="3-2" @click="gotolookupresume()">按时间、岗位查找</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-menu-item index="4" @click="gotorecruitInfoService()">
							<span class="menuText" slot="title">招聘公告维护</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-main class="management_body">
					<addControl v-show="addControlDialog" v-on:addAdmingAccount='addAdmingAccount'></addControl>
					<div class="addPosition_area">
						<div class="addPosition_title">
							<span>岗位新增</span>
						</div>
						<div class="addPosition_info">
							<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px"
								class="ruleForm_info">
								<el-form-item label="岗位类型:">
									<el-radio-group v-model="ruleForm.positiontype">
										<el-radio :label="0">校园招聘岗位</el-radio>
										<el-radio :label="1">社会招聘岗位</el-radio>
										<el-radio :label="2">实习生岗位</el-radio>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="岗位名称:" prop="name">
									<el-input v-model="ruleForm.name"></el-input>
								</el-form-item>
								<!-- <el-form-item label="工作地点:" prop="base">
									<el-input v-model="ruleForm.base"></el-input>
								</el-form-item>
								<el-form-item label="招聘单位:" prop="department">
									<el-input v-model="ruleForm.department"></el-input>
								</el-form-item> -->
								<!-- <el-form-item label="工作职责:" prop="responsibilities">
									<el-input v-model="ruleForm.responsibilities" type="textarea"
										:autosize="{ minRows: 3}"></el-input>
								</el-form-item> -->
								<el-form-item label="招聘条件:" prop="responsibilities">
									<el-input v-model="ruleForm.responsibilities" type="textarea"
										:autosize="{ minRows: 7}"></el-input>
								</el-form-item>
								<!-- <el-form-item label="任职资格:" prop="requirements">
									<el-input v-model="ruleForm.requirements"></el-input>
								</el-form-item> -->
								<el-form-item label="联系人:" prop="contacts">
									<el-input v-model="ruleForm.contacts"></el-input>
								</el-form-item>
							</el-form>
							<div class="add_button_area">
								<el-button class="save_button" type="primary" @click="savePosition()">保 存 岗 位
								</el-button>
								<el-button class="add_button" type="primary" @click="addPosition()">发 布 岗 位</el-button>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import addControl from "../../components/addControl.vue"
	import {
		loginstatus,
		Logout,
		addAdminUser,
		addPosition,
	} from '../../api/user.js';
	export default {
		components: {
			addControl,
		},
		data() {
			var validateName = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('岗位名称不能为空！'));
				} else {
					callback();
				}
			};
			var validateBase = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('工作地点不能为空！'));
				} else {
					callback();
				}
			};
			var validateDepartment = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('招聘单位不能为空！'));
				} else {
					callback();
				}
			};
			var validateResponsibilities = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('工作职责不能为空！'));
				} else {
					callback();
				}
			};
			var validateRequirements = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('任职资格不能为空！'));
				} else {
					callback();
				}
			};
			var validateContacts = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('联系人不能为空！'));
				} else {
					callback();
				}
			};
			return {
				addControlDialog: false,
				userID: '',
				showID: '',
				ruleForm: {
					name: '',
					base: '',
					department: '',
					responsibilities: '',
					requirements: '',
					contacts: '',
					positiontype: 0,
				},
				rules: {
					name: [{
						required: true,
						validator: validateName,
						trigger: 'blur',
					}, ],
					base: [{
						required: true,
						validator: validateBase,
						trigger: 'blur',
					}, ],
					department: [{
						required: true,
						validator: validateDepartment,
						trigger: 'blur',
					}, ],
					responsibilities: [{
						required: true,
						validator: validateResponsibilities,
						trigger: 'blur',
					}, ],
					requirements: [{
						required: true,
						validator: validateRequirements,
						trigger: 'blur',
					}, ],
					contacts: [{
						required: true,
						validator: validateContacts,
						trigger: 'blur',
					}, ],
				},
			};
		},
		mounted() {
			loginstatus().then((res) => {
				if (res.code == 300) {
					let str = res.data;
					this.showID = str.substring(0, 3) + '****' + str.substring(7, 11);
					this.userID = res.datadata
				} else {
					this.$message({
						message: '您不具有管理员权限！',
						type: 'error'
					});
					this.$router.push('/')
				}
			});
		},
		methods: {
			addAdmingAccount(addAdmingAccount) {
				addAdminUser({
					password: addAdmingAccount.adminPassword,
					userID: addAdmingAccount.adminAccount,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '管理员账号添加成功！',
							type: 'success'
						});
						this.addControlDialog = false
					} else {
						this.$message({
							message: '管理员账号添加失败！',
							type: 'error'
						});
						this.addControlDialog = false
					}
				})
			},
			addControl() {
				this.addControlDialog = true
			},
			savePosition() {
				addPosition({
					positionStatus: 0,
					contact: this.ruleForm.contacts,
					positionName: this.ruleForm.name,
					responsibilities: this.ruleForm.responsibilities,
					type: this.ruleForm.positiontype,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '保存岗位成功！',
							type: 'success'
						});
					} else {
						this.$message({
							message: '保存岗位失败！',
							type: 'error'
						});
					}
				})
			},
			addPosition() {
				if (this.ruleForm.name != '' && this.ruleForm.contacts != '' && this.ruleForm.responsibilities != '') {
					addPosition({
						positionStatus: 1,
						contact: this.ruleForm.contacts,
						positionName: this.ruleForm.name,
						responsibilities: this.ruleForm.responsibilities,
						type: this.ruleForm.positiontype,
					}).then((res) => {
						if (res.code == 200) {
							this.$message({
								message: '发布岗位成功！',
								type: 'success'
							});
						} else {
							this.$message({
								message: '发布岗位失败！',
								type: 'error'
							});
						}
					})
				} else {
					this.$message({
						message: '任意参数不能为空！',
						type: 'error'
					});
				}
			},
			exit() {
				Logout().then((res) => {
					this.$router.push('/')
				})
			},
			// gotoadd(){
			// 	this.$router.push('/management/addPosition')
			// },
			gotolookupresumeByName(){
				this.$router.push('/management/lookUpResumeByName')
			},
			gotoreset() {
				this.$router.push('/management/resetPosition')
			},
			gotolookupresume() {
				this.$router.push('/management/lookUpResume')
			},
			gotorecruitInfoService() {
				this.$router.push('/management/arcticList')
			},
		},
	};
</script>

<style scoped>
	@import url(../../assets/css/managementcss.css);

	.addPosition_area {
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		border-radius: 4px;
		width: 50%;
		margin-left: 20%;
		margin-top: 35px;
		padding-bottom: 35px;
	}

	.addPosition_title {
		font-size: 26px;
		font-weight: bold;
		margin-left: 40%;
		padding-top: 25px;
	}

	.addPosition_info {
		width: 80%;
		margin-left: 10%;
		margin-top: 35px;
		padding-top: 25px;
	}

	.ruleForm_info {
		width: 510px;
	}

	.add_button_area {
		margin-left: 34%;
		margin-top: 55px;
	}
</style>
